export enum CrudFormConfigInputChangeReaction {
  Default = 'default',
  Blur = 'blur',
  None = 'none'
}
